<template>
  <section v-if="!isReady || isGetCollectionRequestPending" class="specifications">
    <p-loading />
  </section>

  <section v-else class="specifications">
    <header>
      <h1>Specifications</h1>
      <section class="action-wrapper">
        <router-link v-if="$hasPermission('specifications.write')" to="/specifications/create">+ new</router-link>
      </section>
    </header>

    <section>
      <p-list
        name="specifications"
        :data="filtered"
        :total="total"
        :metadata="{
          name: { label: 'Name', width: 'minmax(0, 3fr)' },
          description: { label: 'Description', width: 'minmax(0, 3fr)' },
          tags: { label: 'Tags', width: 'minmax(100px, 2fr)' },
          type: { label: 'Type', width: '100px' },
          modifiedAt: { label: 'Last modification', width: '175px' }
        }"
        @edit="edit"
      >
        <template #filter>
          <p-checkbox v-model="filter.abstract" label="Abstract"></p-checkbox>
          <p-checkbox v-model="filter.flowchart" label="Flowchart"></p-checkbox>
          <p-checkbox v-model="filter.summary" label="Summary"></p-checkbox>
          <p-checkbox v-model="filter.claims" label="Claims"></p-checkbox>
          <p-checkbox v-model="filter.boilerplate" label="Boilerplate"></p-checkbox>
        </template>
        <template #name="{ value, item }">
          <router-link :to="`/specifications/${item.id}`">{{ value }}</router-link>
        </template>
        <template #__actions="{ item }">
          <p-button variant="text" title="Edit this specification" @click="edit(item.id)"> &#9998;</p-button>
        </template>
      </p-list>
    </section>
  </section>
</template>

<script>
import { mapState } from 'vuex';

import Loading from './../common/Loading';
import Checkbox from '@/components/common/Checkbox';
import Button from '@/components/common/Button';

import List from './../common/List';

import { lw } from '@/utils/lw';

const LOCAL_STORAGE_SPECIFICATION_TYPE_LIST = 'LOCAL_STORAGE_SPECIFICATION_TYPE_LIST';

const SPECIFICATION_TYPE_LIST = ['abstract', 'flowchart', 'summary', 'claims', 'boilerplate', 'claims'];
export default {
  components: {
    'p-list': List,
    'p-loading': Loading,
    'p-checkbox': Checkbox,
    'p-button': Button
  },
  data() {
    const types = lw.get(LOCAL_STORAGE_SPECIFICATION_TYPE_LIST) || SPECIFICATION_TYPE_LIST;

    return {
      filter: SPECIFICATION_TYPE_LIST.reduce(
        (obj, key) => ({
          ...obj,
          [key]: types.includes(key)
        }),
        {}
      ),

      isReady: false
    };
  },
  computed: {
    ...mapState({
      collection: s => s.specifications.collection,
      total: s => s.specifications.total,
      isGetCollectionRequestPending: s => s.specifications.isGetCollectionRequestPending
    }),
    filtered() {
      const types = Object.keys(this.filter).filter(key => !!this.filter[key]);
      return this.collection.filter(item => types.includes(item.type));
    }
  },
  watch: {
    filter: {
      handler() {
        lw.set(
          LOCAL_STORAGE_SPECIFICATION_TYPE_LIST,
          Object.keys(this.filter).filter(key => !!this.filter[key])
        );
      },
      deep: true
    }
  },
  async created() {
    this.$store.dispatch('specifications/getCollection');
    this.isReady = true;
  },
  methods: {
    async edit(id) {
      this.$router.push({ path: `/specifications/${id}/edit` });
    }
  }
};
</script>

<style scoped lang="scss">
.specifications {
  display: grid;
  padding: 0 0.5rem 0 1rem;
  grid-template-columns: 1fr;
  grid-template-rows: max-content minmax(0, 1fr);
  grid-gap: 0.5rem;
  width: 100%;
  height: 100%;

  > header {
    padding: 0.5rem 0.5rem 0;
    display: flex;
    justify-content: space-between;

    box-sizing: border-box;
    h1 {
      color: var(--theme-on-surface);
      font-size: 1.5rem;
      font-weight: 700;
      margin-right: 0.25rem;
    }

    .action-wrapper {
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }
}
</style>
